import { datadogRum } from '@datadog/browser-rum';
import { graphQlRequest } from '@ria-client/supergraph/graphql-client/utils';
import cookies from 'js-cookie';
import { useEffect, useState } from 'react';

type UseIdentityReturnValue = {
  isLoggedIn: boolean;
  loading: boolean;
  error?: {
    message?: string;
  };
  refetch?: () => Promise<unknown>;
  refetching?: boolean;
};

type IdentityResponse = {
  data?: {
    identity?: {
      roles?: string[];
    };
  };
};

function hasIdentity(): boolean {
  return cookies.get('id_token') !== undefined;
}

export const IDENTITY_QUERY = `
  query UserIsLoggedIn {
    rawIdentity {
      data
    }
  }
`;

async function identityCheck(): Promise<IdentityResponse | null> {
  try {
    const res = await graphQlRequest<{ rawIdentity: IdentityResponse }>(IDENTITY_QUERY);
    if (res?.rawIdentity) {
      return {
        ...res.rawIdentity,
      };
    }
    return null;
  } catch (error) {
    datadogRum.addError(error, { message: 'Error in identityCheck' });
    return null;
  }
}

export const useIdentity = (): UseIdentityReturnValue => {
  const [rawIdentity, setRawIdentity] = useState<IdentityResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!hasIdentity()) {
      setIsLoading(false);
      return;
    }
    identityCheck().then(res => {
      if (res) {
        setRawIdentity(res);
        setIsLoading(false);
      }
    });
  }, []);

  const isLoggedIn = !!rawIdentity?.data;

  return {
    isLoggedIn,
    loading: isLoading,
  };
};
